export const HOME = '/home';
export const LOGIN = '/auth/login';
export const LOGOUT = '/auth/logout';
export const POLICY = '/policy';
export const PROFILE = '/profile';
